
export interface ISpeedSensorMetrics {
  /* Speed in km/h*/
  speed: number;

  /*Time in unix timestamp*/
  time: number;
}

